import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { getFormValues } from 'redux-form';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import ContactForm from '../modules/ContactForm';
import { fetchContactDetail } from '../modules/ContactDetail/actions';
import { deleteContact } from '../modules/ContactList/actions';
import { isLoaded, getError } from '../modules/ContactDetail/selectors';
import { CONTACT_FORM_NAME } from '../modules/ContactForm/constants';

class EditContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { id, lang } = this.props.match.params;
    this.props.fetchContactDetail(id, lang);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  /*   deleteContact = () => {
    const { id, lang } = this.props.match.params;
    this.props.deleteContact(id, lang, () => {
      this.props.history.push('/kontakt');
    });
  }; */

  render() {
    const { isLoaded, contactInitialValues, match } = this.props;
    const { lang } = match.params;

    const initialValues = { ...contactInitialValues, lang };

    return (
      <Layout>
        <Container>
          <Loader loaded={isLoaded}>
            <PageNav>
              <h1>Upravit kontakt</h1>
            </PageNav>
            <ContactForm
              config={this.getConfig()}
              initialValues={initialValues}
            />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    contactInitialValues: getFormValues(CONTACT_FORM_NAME)(state),
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchContactDetail, deleteContact }
)(EditContactPage);



// WEBPACK FOOTER //
// ./src/pages/EditContactPage.js